import React from 'react';
import { useDetailsModal } from '../context/DetailsModalContext';
import { LINK_TEXT } from '../utils/clickable';

// A client's name that opens the client's details (staff only). Without a
// client id, or for a client account, it is plain text.
const ClientLink = ({ clientId, name, children, className = '', title }) => {
  const { openClient, canViewClients } = useDetailsModal();
  const label = children ?? name ?? '-';
  if (!clientId || !canViewClients) return <span className={className}>{label}</span>;
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); openClient(clientId, typeof name === 'string' ? name : ''); }}
      className={`${LINK_TEXT} text-left p-0 bg-transparent border-0 ${className}`}
      title={title || 'Open client details'}
    >
      {label}
    </button>
  );
};

export default ClientLink;
